import { Building } from 'iconoir-react';

import { FlagImage } from '@savgroup-front-common/core/atoms/FlagImage/FlagImage';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { ComboboxItem } from '@savgroup-front-common/primitive/ui/combobox';

import { MANUAL_ENTRY } from './CompanySearchItem.constants';
import { formatCompanySearchDetails } from './CompanySearchItem.formatters';
import { CompanySearchOption } from './CompanySearchItem.types';
import messages from './messages';

interface CompanySearchItemProps {
  item: CompanySearchOption;
}

export function CompanySearchItem({ item }: CompanySearchItemProps) {
  if (item === MANUAL_ENTRY) {
    return (
      <ComboboxItem
        value={item}
        className="border-t sborder-base-default"
        data-testid="OnboardingForm-companyManualEntry"
      >
        <Building aria-hidden className="size-4 stext-muted-default" />
        <SafeFormattedMessageWithoutSpread message={messages.manualEntry} />
      </ComboboxItem>
    );
  }

  return (
    <ComboboxItem value={item}>
      <span className="flex min-w-0 w-full flex-col items-start gap-0.5">
        <span className="flex min-w-0 w-full items-start gap-3">
          <span className="flex min-w-0 flex-1 flex-col gap-0.5">
            <span className="flex min-w-0 items-center gap-2">
              <FlagImage
                iso2={item.address?.countryCode?.toLowerCase()}
                size={spacing(4)}
              />
              <span className="min-w-0 break-words text-sm font-semibold stext-primary-default">
                {item.name}
              </span>
            </span>
            <span className="text-xs stext-muted-default">
              {formatCompanySearchDetails(item)}
            </span>
          </span>
          {item.facts?.activitySector && (
            <span className="min-w-0 max-w-[45%] break-words text-right text-xs stext-muted-default">
              {item.facts.activitySector}
            </span>
          )}
        </span>
        {!item.isActive && (
          <span className="text-xs stext-danger-default">
            <SafeFormattedMessageWithoutSpread
              message={messages.inactiveCompany}
            />
          </span>
        )}
      </span>
    </ComboboxItem>
  );
}
